/**
 * WYF Auto-FAITH Discount
 * Automatically applies the FAITH discount code when cart has 3+ items.
 * Removes it when cart drops below 3 items.
 * Works on both cart page and cart drawer.
 */
(function() {
  'use strict';

  const FAITH_CODE = 'FAITH';
  const MIN_ITEMS = 3;
  let isApplying = false;

  function getCartItemCount() {
    // Try cart drawer badge first
    const badge = document.querySelector('.theme-drawer__badge');
    if (badge) {
      const count = parseInt(badge.textContent.trim(), 10);
      if (!isNaN(count)) return count;
    }
    // Try cart page count
    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) {
      const count = parseInt(cartCount.textContent.trim(), 10);
      if (!isNaN(count)) return count;
    }
    return 0;
  }

  async function getCurrentDiscounts() {
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) return [];
      const cart = await response.json();
      return cart.discount_codes || [];
    } catch (e) {
      return [];
    }
  }

  async function applyOrRemoveFaith() {
    if (isApplying) return;
    isApplying = true;

    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const itemCount = cart.item_count;
      const existingDiscounts = cart.discount_codes || [];
      const hasFaith = existingDiscounts.some(d => d.code && d.code.toUpperCase() === FAITH_CODE);

      if (itemCount >= MIN_ITEMS && !hasFaith) {
        // Apply FAITH code
        const allCodes = [...existingDiscounts.map(d => d.code), FAITH_CODE];
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: allCodes.join(',') })
        });
        // Trigger a section re-render if possible
        if (window.cartPerformance) {
          window.dispatchEvent(new CustomEvent('cart:updated'));
        }
      } else if (itemCount < MIN_ITEMS && hasFaith) {
        // Remove FAITH code
        const remainingCodes = existingDiscounts.filter(d => d.code.toUpperCase() !== FAITH_CODE).map(d => d.code);
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') })
        });
        if (window.cartPerformance) {
          window.dispatchEvent(new CustomEvent('cart:updated'));
        }
      }
    } catch (e) {
      // Silent fail - don't break the cart
      console.warn('WYF Auto-FAITH:', e.message);
    } finally {
      isApplying = false;
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOrRemoveFaith);
  } else {
    applyOrRemoveFaith();
  }

  // Listen for cart updates
  window.addEventListener('cart:updated', () => setTimeout(applyOrRemoveFaith, 300));
  window.addEventListener('ajaxCart:updated', () => setTimeout(applyOrRemoveFaith, 300));

  // Mutation observer for cart drawer badge changes
  const observer = new MutationObserver(() => {
    setTimeout(applyOrRemoveFaith, 500);
  });

  // Observe cart drawer when it appears
  function setupObserver() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true, characterData: true });
    }
    const cartPage = document.getElementById('cart');
    if (cartPage) {
      observer.observe(cartPage, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();
